import { negate } from 'lodash';

export type Just<T> = ['just', T];
export const Just = <T>(value: T): Just<T> => ['just', value];

export type Nothing = ['nothing'];
const _Nothing: Nothing = ['nothing'];

export const Nothing = (): Nothing => _Nothing;

export type Maybe<T> = Just<T> | Nothing;

export const ofNullable = <T>(
  value: NonNullable<T> | null,
): Maybe<NonNullable<T>> => (value == null ? Nothing() : Just(value));
export const valueOf = <T>(maybe: Maybe<T>): T | null =>
  maybe[0] === 'nothing' ? null : maybe[1];
export const isEmpty = <T>([type]: Maybe<T>) => type === 'nothing';
export const isPresent = negate(isEmpty);
export const map =
  <T, R>(mapper: (t: T) => R) =>
  (maybe: Maybe<T>): Maybe<R> =>
    maybe[0] === 'nothing' ? Nothing() : Just(mapper(maybe[1]));
export const mapTo = <R>(value: R) => map(() => value);
export const orElse =
  <T>(otherwise: T) =>
  (maybe: Maybe<T>): T =>
    maybe[0] === 'nothing' ? otherwise : maybe[1];
export const orUndefined = <T>(maybe: Maybe<T>): T | undefined =>
  maybe[0] === 'nothing' ? undefined : maybe[1];
export const flatten = <T>(deep: Maybe<Maybe<T>>): Maybe<T> =>
  deep[0] === 'nothing' ? Nothing() : deep[1];
export const flatMap =
  <T, R>(mapper: (t: T) => Maybe<R>) =>
  (maybe: Maybe<T>): Maybe<R> =>
    flatten(map(mapper)(maybe));
export const filter = <T>(predicate: (t: T) => boolean) =>
  flatMap((x: T) => (predicate(x) ? Just(x) : Nothing()));
export const ifPresent =
  <T>(action: (value: T) => void) =>
  (maybe: Maybe<T>): Maybe<T> => {
    if (maybe[0] === 'just') {
      action(maybe[1]);
    }

    return maybe;
  };
export const ifEmpty =
  <T>(action: () => void) =>
  (maybe: Maybe<T>): Maybe<T> => {
    if (maybe[0] === 'nothing') {
      action();
    }

    return maybe;
  };
